import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import NettingUpdaterForm from './NettingUpdaterForm'
import NettingFtpsForm from './NettingFtpsForm'
import NettingApiForm from './NettingApiForm'
import NettingBatchList from './NettingBatchList'

const NETTING_FORMS = {
  file_upload: NettingUpdaterForm,
  ftps: NettingFtpsForm,
  api: NettingApiForm,
}

const NettingUpdaterPage = () => {
  const [css, theme] = useStyletron()
  const { t } = useTranslation('organizationManagement')
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)

  const nettingType = selectedProvider?.netting_process_type || 'file_upload'
  const FormComponent = NETTING_FORMS[nettingType] || NettingUpdaterForm

  const blockStyle = css({
    padding: '1rem',
    marginBottom: '2rem',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(20,96,170,.15)',
    maxWidth: '480px',
    color: theme.colors.contentSecondary,
  })

  const headingStyle = css({
    margin: '0.5rem 5px 5px 5px',
    color: theme.colors.primary,
  })

  return (
    <div className={css({ padding: '1rem', color: 'white' })}>
      <div className={blockStyle}>
        <h2 className={headingStyle}>{t('netting.page_title')}</h2>
        <FormComponent />
        <NettingBatchList />
      </div>
    </div>
  )
}

export default NettingUpdaterPage
